import { Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { TemplateField } from '../../../models/template.model';

@Component({
  // eslint-disable-next-line
  selector: 'compare-record-header',
  templateUrl: './compare-record-header.component.html',
  styleUrls: ['./compare-record-header.component.scss'],
  standalone: false,
})
export class CompareRecordHeaderComponent implements OnInit, OnDestroy {
  @Input() allFields: TemplateField[];
  @Input() showGroup: boolean;
  @Input() confidentialityTmpl: TemplateRef<any>;

  ngOnInit() {
    /* required for static lable translation */
  }

  ngOnDestroy() {
    /* label translation purpose added */
  }
}
